import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, timeout } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ClasseComposant {
  id: number;
  nom: string;
}

@Injectable({ providedIn: 'root' })
export class ClassesComposantsService {
  private readonly baseUrl = `${environment.apiBaseUrl}/api/classes-composants`;
  private readonly requestTimeoutMs = 30000;

  constructor(private readonly http: HttpClient) {}

  list(): Observable<ClasseComposant[]> {
    return this.http
      .get<{ items?: ClasseComposant[] } | ClasseComposant[]>(this.baseUrl)
      .pipe(
        timeout(this.requestTimeoutMs),
        map((response) => {
          if (Array.isArray(response)) {
            return response;
          }
          return Array.isArray(response?.items) ? response.items : [];
        })
      );
  }

  create(nom: string): Observable<ClasseComposant> {
    return this.http
      .post<ClasseComposant>(this.baseUrl, { nom })
      .pipe(timeout(this.requestTimeoutMs));
  }

  update(id: number, nom: string): Observable<ClasseComposant> {
    return this.http
      .put<ClasseComposant>(`${this.baseUrl}/${id}`, { nom })
      .pipe(timeout(this.requestTimeoutMs));
  }

  getComposantsCount(id: number): Observable<number> {
    return this.http
      .get<{ composants_count?: number }>(`${this.baseUrl}/${id}/composants-count`)
      .pipe(
        timeout(this.requestTimeoutMs),
        map((response) => Number(response?.composants_count ?? 0))
      );
  }

  delete(id: number): Observable<{ deleted: boolean; id: number }> {
    return this.http
      .delete<{ deleted: boolean; id: number }>(`${this.baseUrl}/${id}`)
      .pipe(timeout(this.requestTimeoutMs));
  }
}
